/**
 * URL-hash keys for the registration feature's deep-linkable overlays, bound
 * via `useHashDialog` / `useHashParamDialog` (see `@/hooks/use-hash-dialog`).
 * Row-scoped overlays carry the entity id as a hash param (`#edit/5`).
 */
export const REGISTRATION_HASH = {
  /** `#edit/<id>` — RegistrationFormDialog editing a specific registration. */
  edit: 'edit',
  /**
   * `#view/<id>` — RegistrationDetailDialog for a specific registration.
   * Reserved: the dialog currently has no live consumer in the app, so no
   * listing wires this key yet. Kept for when a detail view is surfaced.
   */
  view: 'view',
  /** `#qr/<id>` — RegistrationSuccessDialog surfaced as a QR viewer per row. */
  qr: 'qr',
  /** `#delete/<id>` — single-registration delete confirmation. */
  delete: 'delete',
  /** `#bulk-delete` — bulk delete confirmation (action bar). */
  bulkDelete: 'bulk-delete'
} as const;

export type RegistrationHashKey =
  (typeof REGISTRATION_HASH)[keyof typeof REGISTRATION_HASH];
